export const statusProject = [
  {
    text: "見込み",
    value: 1
  },
  {
    text: "見積中",
    value: 2
  },
  {
    text: "見積提出",
    value: 3
  },
  {
    text: "受注",
    value: 4
  },
  {
    text: "施工前",
    value: 5
  },
  {
    text: "施工中",
    value: 6
  },
  {
    text: "施工終了",
    value: 7
  },
  {
    text: "未請求",
    value: 8
  },
  {
    text: "請求済",
    value: 9
  },
  {
    text: "入金済",
    value: 10
  }
];

export const statusSearch = [
  {
    text: "(ステータス)",
    value: ""
  },
  {
    text: "失注",
    value: 12
  },
  {
    text: "保留",
    value: 11
  },
  ...statusProject
];

export const listStatus: string[] = [
  "失注",
  "保留",
  "見込み",
  "見積中",
  "見積提出",
  "受注",
  "施工前",
  "施工中",
  "施工終了",
  "未請求",
  "請求済",
  "入金済"
];

export const statusSearchDashboard = [
  {
    text: "全て",
    value: ""
  },
  {
    text: "失注",
    value: 12
  },
  {
    text: "保留",
    value: 11
  },
  {
    text: "見込み",
    value: 1
  },
  {
    text: "見積中",
    value: 2
  },
  {
    text: "見積提出",
    value: 3
  },
  {
    text: "受注",
    value: 4
  },
  {
    text: "未着工",
    value: 13
  },
  {
    text: "施工前",
    value: 5
  },
  {
    text: "施工中",
    value: 6
  },
  {
    text: "施工終了",
    value: 7
  },
  {
    text: "未請求",
    value: 8
  },
  {
    text: "請求済",
    value: 9
  },
  {
    text: "入金済",
    value: 10
  }
];

export function getStatusCode(name: string) {
  const status = statusSearchDashboard.find(item => item.text == name);
  if (status) {
    return status.value;
  }

  return 1;
}

export const STATUS_SUCCESS = 4;
